import { useMemo } from 'react';
import { useEarlyAccess } from './useEarlyAccess';

export interface EngagementMenuOption {
    id: string;
    value: string;
}

const ENGAGEMENT_MENU_OPTIONS: EngagementMenuOption[] = [
    {
        id: '1',
        value: 'DELETE',
    },
    {
        id: '2',
        value: 'DUPLICATE',
    },
    {
        id: '3',
        value: 'TEST',
    },
    {
        id: '4',
        value: 'ENGAGEMENT LOG',
    },
];

/**
 * Returns the available menu options for engagement flow rows.
 * Filters options based on tenant early-access settings.
 */
export const useEngagementMenuOptions = (): EngagementMenuOption[] => {
    const { isEarlyAccessEnabled } = useEarlyAccess();

    return useMemo(() => {
        return ENGAGEMENT_MENU_OPTIONS.filter(
            (option) => option.value !== 'ENGAGEMENT LOG' || isEarlyAccessEnabled,
        );
    }, [isEarlyAccessEnabled]);
};
